import { useState } from "react";

import { INITIAL_STEP, SUCCESS_STEP } from "constants/steps";
import Card, { CARD_LONG } from "../Card";
import ErrorStep from "../ErrorStep";
import InitialStep from "./InitialStep";
import SuccessStep from "./SuccessStep";

function AddNewPartner() {
  const [step, setStep] = useState(INITIAL_STEP);
  const [partnerDetails, setPartnerDetails] = useState(null);

  function renderCardContent() {
    if (step === INITIAL_STEP) {
      return (
        <InitialStep setStep={setStep} setPartnerDetails={setPartnerDetails} />
      );
    } else if (step === SUCCESS_STEP && partnerDetails) {
      return <SuccessStep setStep={setStep} partnerDetails={partnerDetails} />;
    }

    return <ErrorStep setStep={setStep} />;
  }

  return (
    <Card title="Add a new partner" variant={CARD_LONG}>
      {renderCardContent()}
    </Card>
  );
}

export default AddNewPartner;
